<template>
  <div class="mb-5">
    <CardFotoProduto
      :produtos="produtos"
    />
    <v-card class="pa-5 pb-2">
      <p
        v-if="$vuetify.breakpoint.smAndDown"
        class="primary--text"
        data-cy="entrega_nome_produto"
      >
        <span
          v-for="(produto, index) in produtos"
          :key="index"
          class="d-block"
          :data-cy="`entrega_nome_produto_${index}`"
        >
          {{ produto.name }} - {{ produto.plan_name }}
        </span>
      </p>

      <InfoAcompanharEnvio
        v-if="dadosDaCompra.tracking_code"
        class="mb-7"
        :codigo-rastreio="dadosDaCompra.tracking_code"
        :servico-rastreio="dadosDaCompra.tracking_service_slug || ''"
        :transportadora-nome="dadosDaCompra.tracking_service_name"
        :venda-id="dadosDaCompra.id"
        mostrar-ultimo-status
      />

      <p
        class="primary--text mb-3 subtitle-2 font-weight-bold text-uppercase text-center"
        data-cy="label_endereco_de_entrega"
      >
        Endereço de entrega
      </p>
      <p
        class="mb-0 grey--text text--darken-2"
        data-cy="entrega_endereco"
      >
        {{ dadosEntrega.address }},
        {{ dadosEntrega.number }}
      </p>
      <p
        class="mb-0 grey--text text--darken-2"
        data-cy="entrega_complemento"
      >
        {{ dadosEntrega.complement }}
      </p>
      <p
        class="mb-0 grey--text text--darken-2"
        data-cy="entrega_bairro"
      >
        {{ dadosEntrega.neighbourhood }},
        {{ dadosEntrega.city }},
        {{ dadosEntrega.state }}
      </p>
      <p
        class="mb-0 grey--text text--darken-2"
        data-cy="entrega_cep"
      >
        CEP {{ dadosEntrega.zipcode }}
      </p>
      <v-card-actions
        v-if="downloads.length > 0"
        class="flex-column pa-0 mt-3"
      >
        <BtnBaixarAquivos
          :downloads="downloads"
          :venda-id="dadosDaCompra.id"
          outlined
        />
      </v-card-actions>

      <a
        v-if="paginaVendas"
        :href="paginaVendas"
        target="_blank"
        class="text-decoration-none white--text"
        @click.stop
      >
        <v-alert
          class="mt-4"
          color="info"
          dark
          dense
          data-cy="informacao_prazo_de_entrega"
        >
          Verifique o prazo de entrega na página de vendas do produto.
        </v-alert>
      </a>
    </v-card>
  </div>
</template>

<script>

import BtnBaixarAquivos from '@/components/Compras/BtnBaixarAquivos.vue';
import CardFotoProduto from '@/components/Compras/CardFotoProduto.vue';
import InfoAcompanharEnvio from './InfoAcompanharEnvio.vue';

export default {
  name: 'CardEnderecoEntrega',

  components: {
    BtnBaixarAquivos,
    CardFotoProduto,
    InfoAcompanharEnvio,
  },

  props: {
    dadosEntrega: {
      type: Object,
      required: true,
    },
    dadosDaCompra: {
      type: Object,
      required: true,
    },
    produtos: {
      type: Array,
      required: true,
    },
    paginaVendas: {
      type: String,
      default: '',
    },
  },

  computed: {

    downloads() {
      return this.produtos.reduce(
        (acumulator, product) => [...acumulator, ...product.downloads],
        [],
      );
    },
  },
};
</script>
